// NOTE: styles.css is exported as a separate entry point in package.json
// Users should import it explicitly: import '@trycourier/react-designer/styles.css'

export * from "./components/TemplateEditor";
export * from "./components/BrandEditor";
export * from "./components/Providers";

// Isolated v2 subtree (self-contained brand footer + rich-text editor).
export * from "./v2";
// export * from "./components/EditorProvider";

// Hooks
export * from "./components/hooks";

// Types
export type { VariableValidationConfig, VariableValidationContext } from "./types/validation.types";
export type { FontEntry, FontProvider } from "./types/font.types";

// Error handling utilities
export * from "./lib/utils/errors";
export * from "./components/ui-kit/ErrorBoundary";

export { CHANNELS } from "@/channels";
export type { ChannelType } from "@/store";
export type { ElementalContent } from "@/types";

export { PreviewPanel } from "@/components/ui/PreviewPanel";
export { Tooltip } from "@/components/ui/Tooltip";
export { TextMenu } from "@/components/ui/TextMenu";
export { VariableInput, VariableTextarea } from "@/components/ui/VariableEditor";
export { getFlattenedVariables } from "@/components/utils/getFlattenedVariables";
export { Status as TemplateStatus } from "@/components/ui/Status";

export {
  ToggleGroup,
  ToggleGroupItem,
  Toggle,
  Divider,
  Input,
  InputColor,
  DEFAULT_PRESET_COLORS,
  FontSelect,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@/components/ui-kit";

export { ThemeProvider, useTheme } from "@/components/ui-kit/ThemeProvider";
export {
  defaultTheme,
  lightTheme,
  darkTheme,
} from "@/components/ui-kit/ThemeProvider/ThemeProvider.types";
export type { Theme } from "@/components/ui-kit/ThemeProvider/ThemeProvider.types";

export {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  MediumIcon,
  XIcon,
} from "@/components/ui-kit/Icon";

export {
  cn,
  convertElementalToTiptap,
  convertTiptapToElemental,
  parseFontFamily,
  buildFontFamily,
} from "@/lib/utils";
export { blockDefaults } from "@/lib/constants/block-defaults";
export {
  EMAIL_EDITOR_TEXT_STYLES,
  EMAIL_EDITOR_FONT_FAMILY,
} from "@/lib/constants/email-editor-tiptap-styles";

export { useAutoSave } from "@/hooks/useAutoSave";
export { useLocalization } from "@/hooks/useLocalization";
export type {
  TranslatableField,
  UseLocalizationOptions,
  UseLocalizationResult,
} from "@/hooks/useLocalization";
export {
  extractExistingLocales,
  extractTextFields,
  updateLocaleTranslation,
  updateLocaleTranslationWithElements,
} from "@/lib/utils/extractTextFields";
export { useGoogleFontLoader } from "@/components/TemplateEditor/hooks/useGoogleFontLoader";

export { TranslationEditor, getTranslationToolbarConfig } from "@/components/TranslationEditor";
export type {
  TranslationEditorProps,
  TranslationEditorToolbarConfig,
} from "@/components/TranslationEditor";
export { getTextMenuConfigForNode } from "@/components/ui/TextMenu/config";
export type { TextMenuConfig } from "@/components/ui/TextMenu/config";
export { convertElementsArrayToTiptapNodes } from "@/lib/utils/convertElementalToTiptap/convertElementalToTiptap";

export { MonacoCodeEditor } from "@/components/extensions/HTML/MonacoCodeEditor";

// Shadow DOM compatibility
export { applyShadowDomDndFix } from "@/components/utils/shadowDomDndFix";

// Locale preview
export { previewLocaleAtom } from "@/components/TemplateEditor/store";
